import type { FC, SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {}

const GraduatedIcon: FC<Props> = (props) => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-labelledby="titleId"
      {...props}
     aria-label="graduate icon">
      {/* <title>graduate icon</title> */}
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.91 5.52753C12.3107 5.23432 11.6101 5.23432 11.0109 5.52753L4.97783 8.47622C4.97778 8.47624 4.97788 8.47619 4.97783 8.47622C4.14575 8.88325 4.14541 10.0702 4.97856 10.4773L11.1714 13.5042C11.7342 13.7232 12.3655 13.6989 12.913 13.4313L18.9504 10.4809C19.7834 10.0738 19.7834 8.88613 18.9504 8.47901L12.91 5.52753ZM10.6091 14.7704L10.6864 14.8083C10.751 14.8398 10.8181 14.8604 10.8856 14.8708C11.7502 15.1446 12.6941 15.0795 13.5209 14.6754L16.2152 13.3587V16.7784C16.2152 17.2966 15.908 17.7635 15.4509 17.955C13.0841 18.9463 10.7247 18.9359 8.32924 17.9473C7.86807 17.7566 7.5584 17.2885 7.5584 16.7676V13.2879L10.3972 14.6754C10.467 14.7095 10.5377 14.7412 10.6091 14.7704ZM6.17379 12.6027V16.7676C6.17379 17.8273 6.80165 18.8142 7.80071 19.227C10.5283 20.3527 13.2707 20.3694 15.9858 19.2321C16.9783 18.8164 17.5998 17.8319 17.5998 16.7784V12.6821L19.5584 11.7249C19.5624 11.7229 19.5666 11.7209 19.5707 11.7188L19.5539 14.4632C19.5515 14.8456 19.8597 15.1574 20.242 15.1597C20.6243 15.1621 20.9362 14.8541 20.9385 14.4716L20.969 9.47433C20.9693 9.4262 20.9647 9.37919 20.9556 9.33377C20.9075 8.48956 20.4417 7.66668 19.5584 7.23498L13.5185 4.28376C13.5184 4.28372 13.5186 4.28382 13.5185 4.28376C12.5354 3.80294 11.3857 3.8028 10.4027 4.28365L4.36969 7.2323C2.50205 8.14562 2.50216 10.8082 4.37058 11.7213C4.37057 11.7213 4.37059 11.7213 4.37058 11.7213L6.17379 12.6027Z"
        fill={props.fill || "currentColor" || "#202123"}
      />
    </svg>
  );
};

export default GraduatedIcon;
